import { render, staticRenderFns } from "./orderDetailBox.vue?vue&type=template&id=76df7c8e&"
import script from "./orderDetailBox.vue?vue&type=script&lang=ts&"
export * from "./orderDetailBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports